var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8323 6.65786L16.2792 6.61015V6.16068V1.27046L25.1372 10.7812L16.2792 20.2919V15.4017V14.9017H15.7792C12.1404 14.9017 9.01327 15.4877 6.32794 16.7801C4.32826 17.7426 2.58963 19.0892 1.07431 20.8514L1.62121 18.6494L1.88773 18.0771L1.89714 18.0569L1.9047 18.0359C3.02564 14.9344 4.92327 12.2316 7.38269 10.2247C9.84176 8.21814 12.7667 6.98512 15.8323 6.65786Z",
    stroke: "#333132"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.6f6011a7d6bff0a20c7f90795a4b6fc8.svg";
export { ForwardRef as ReactComponent };